import template from './tool-tip.template.html';
import DebouncedToggle from '../debounced-toggle';

export class ToolTipController extends DebouncedToggle {
	constructor($timeout) {
		'ngInject';
		super($timeout);
		this.toggleHelp = false;
	}

	$onInit() {}

	// toggleInstructions() {
	// 	this.toggleHelp = !this.toggleHelp;
	// }

	// closeTip() {
	// 	this._debounceToggle()
	// 		.then(() => {
	// 			this.toggleHelp = false;
	// 		})
	// 		.catch(this._ignore);
	// }
}

export const ToolTipComponent = {
	template,
	controller: ToolTipController,
	controllerAs: 'vm',
	bindings: {
		helpContent: '<',
		position: '<'
	}
};
